import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * LEGACY: Workflow ID for delivery operations.
 */
export const schema = z.number().int().positive();

export type DeliveryWorkflowId = z.infer<typeof schema>;

export const definition = define({
  key: 'delivery_workflow_id',
  schema,
  label: 'Delivery Workflow ID',
  description: 'LEGACY: Workflow ID for delivery operations. Defines driver steps during vehicle delivery.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.WORKFLOWS.key,
  writableAtLevels: [LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  deprecated: true,
});
